'use client';

import * as layout from '@ocodelib/compose-layout';
import { useEffect, useRef, useState } from 'react';
import { buildLayout } from './layout/build-layout';
import { LayoutRoot } from './layout/LayoutRoot';
import { PyBasicAppProvider } from './PyBasicAppProvider';
import type { IAppConfig, IPyBasicLayoutConfig, PyBasicAppType } from './types';

interface Props {
  appConfig: IAppConfig;
  onLayoutBuild?: (layoutManager: layout.ComposeLayoutManager) => void;
  onLoadApp?: (app: PyBasicAppType | null) => void;
}

export function PyBasicAppUi(props: Props) {
  const { appConfig, onLoadApp } = props;
  const onLayoutBuildRef = useRef(props.onLayoutBuild);
  onLayoutBuildRef.current = props.onLayoutBuild;

  const [appInfo, setAppInfo] = useState<{
    layoutManager: layout.ComposeLayoutManager;
    layoutConfig: IPyBasicLayoutConfig;
  }>();

  useEffect(() => {
    const { dispose, result } = buildLayout(onLayoutBuildRef.current);
    setAppInfo(result);
    return () => {
      dispose();
      setAppInfo(undefined);
    };
  }, []);

  if (!appInfo) {
    return null;
  }

  return (
    <layout.ComposeLayout layoutManager={appInfo.layoutManager}>
      <PyBasicAppProvider
        layoutConfig={appInfo.layoutConfig}
        appConfig={appConfig}
        onLoadApp={onLoadApp}
      >
        <LayoutRoot className="PyBasicAppUi-layoutRoot" />
      </PyBasicAppProvider>
    </layout.ComposeLayout>
  );
}
